import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import axios from "axios";
import InputPagamento from "../components/Inputs/InputPagamento";
import { CheckCheck, ChevronLeft, LoaderCircle, OctagonAlert } from "lucide-react";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from "../services/api";

export default function TaxaInstalacao() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [mensagemInput, setMensagemInput] = useState("");
  const [numero, setNumero] = useState("");
  const [pago, setPago] = useState(false);

  const gerarLetrasAleatorias = (tamanho) => {
    const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let resultado = "";
    for (let i = 0; i < tamanho; i++) {
      resultado += letras.charAt(Math.floor(Math.random() * letras.length));
    }
    return resultado;
  };

  const gerarDataAtual = () => {
    const dataAtual = new Date();
    // Obtém as partes da data
    const ano = dataAtual.getFullYear();
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
    const dia = String(dataAtual.getDate()).padStart(2, "0");

    // Obtém as partes do horário
    const horas = String(dataAtual.getHours()).padStart(2, "0");
    const minutos = String(dataAtual.getMinutes()).padStart(2, "0");
    const segundos = String(dataAtual.getSeconds()).padStart(2, "0");

    // Constrói a data no formato desejado
    const dataFormatada = `${ano}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
    return dataFormatada;
  };

  async function mostrarPlano() {
    try {
      const token = localStorage.getItem("token");
      if(token){
        const dadosUsuario = jwtDecode(token)
        if(dadosUsuario){
          const dadosAtuais = await axios.get(
            `${API_BASE_URL}/usuario/${dadosUsuario.idUsuario}`,
            {
              headers: {
                'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
              }
            }
          );
         if(dadosAtuais){
          console.log(dadosAtuais.data)
         }
        }
      }
      
    } catch (erro) {
      console.log(erro);
    }
  }

  async function recarregarPacote() {
    setMensagemInput("");
    setLoading(true);
    try {
    const token = localStorage.getItem("token");
      if (!/^(84|85)\d{7}$/.test(numero)) {
        console.log(
          "Número de telefone inválido. Deve começar com 84 ou 85 e conter 9 dígitos."
        );
        setLoading(false);
        setMensagemInput(
          "Por favor, insira um número de telefone válido no maximo 9 numeros começando com 84 ou 85."
        );
        return;
      }
      let valoresAleatorios = gerarLetrasAleatorias(12);
      if(token){
        const dadosDoLocalStorage = jwtDecode(token)
        if(dadosDoLocalStorage){
          const dados = await axios.put(
            `${API_BASE_URL}/pagamento/${dadosDoLocalStorage.idUsuario}`,
            {
              transaction_ref: "EyazsImperium",
              msisdn: `258${numero}`,
              amount: parseFloat(1500),
              thirdparty_ref: valoresAleatorios,
            },
            {
              headers: {
                'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
              }
            }
          );
          if (dados) {
              try {
                const atualizarPlano = await axios.put(
                  `${API_BASE_URL}/usuario/${dadosDoLocalStorage.idUsuario}`,
                  {
                    profile:"default"
                  },
                  {
                    headers: {
                      'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                      'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                    }
                  }
                );
                  if (atualizarPlano) {
                      try {
                        const dataAtual = gerarDataAtual();
                        const gerarRecibo = await axios.post(
                          `${API_BASE_URL}/recibo`,
                          {
                            idUsuario: dadosDoLocalStorage.idUsuario,
                            userName: dadosDoLocalStorage.name,
                            meioPagamento: "Mpesa",
                            numeroTelefone: numero,
                            valor: parseFloat(1500),
                            plano: "default",
                            descricao: "Taxa de Instalacao",
                            dataTransacao: dataAtual,
                          },
                          {
                            headers: {
                              'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
                              'Content-Type': 'application/json'  // Define o tipo de conteúdo como JSON
                            }
                          }
                        );
                        if (gerarRecibo) {
                          console.log("Recibo gerado com Sucesso!");
                          setNumero("");
                          setPago(true);
                        }
                      } catch (erro) {
                        console.log(erro);
                      }
                    console.log("Plano atualizado com Sucesso!");
                  }
              } catch (erro) {
                console.log(erro);
              }
            console.log(dados.data);
          }
        }
      }
    } catch (erro) {
      console.log(erro);
    } finally {
      setLoading(false);
    }
  }

  const propsInputPagamentoMpesa = {
    type: "text",
    placeholder: "digite o numero do Mpesa",
    mudar: (e) => setNumero(e.target.value),
    value: numero,
  };

  useEffect(() => {
    mostrarPlano();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* NavBar */}
      <div className="bg-blue-500 sticky top-0">
        <NavBar />
      </div>

      {/* Conteúdo Principal */}
      {pago ? (
        <div>
          <div className="flex justify-center items-center h-full">
            <div className="bg-green-700 m-8 text-white p-6 md:p-10 rounded-3xl shadow-2xl max-w-md w-full text-center">
              <div className="flex justify-center mb-4">
                <CheckCheck size={50} strokeWidth={2} />
              </div>
              <h1 className="text-2xl md:text-3xl font-bold mb-2">
                Pagamento Confirmado!
              </h1>
              <p className="text-lg md:text-xl mb-4">
                Obrigado pelo seu pagamento. Sua Taxa de Instalacao foi Paga com Sucesso!
              </p>
              <Link
                to="/home"
                className="inline-block mt-4 px-6 py-2 rounded-lg bg-green-500 text-gray-100 hover:bg-green-600 transition duration-300 font-semibold"
              >
                Voltar à Página Inicial
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex-grow flex flex-col justify-between font-questrial">
          <button
            className="group ml-6 my-2"
            onClick={() => {
              navigate(-1);
            }}
          >
            <div className="flex md:flex lg:hidden">
              <div>
                <ChevronLeft className="group-hover:font-semibold" />
              </div>
              <div>
                <span className="text-sm group-hover:font-semibold">
                  Voltar
                </span>
              </div>
            </div>
          </button>
          {/* Título do Perfil */}
          <div className="h-[60px] border flex items-center justify-center bg-gray-100">
            <h1 className="font-semibold">Taxa de Instalacao</h1>
          </div>

          {/* Seção de Pagamento */}
          <div className="border lg:mx-auto w-[80%] mx-auto sm:mx-auto sm:w-[40%] md:w-[40%] lg:w-[40%] bg-gray-50 my-6 p-6 rounded-lg shadow-md">
            {/* Logotipo */}
            <div className="flex justify-center mb-6">
              <img
                className="w-[170px]"
                src="../../images/vodacom.png"
                alt="Vodacom"
              />
            </div>

            {/* Total */}
            <div className="flex justify-between mb-4 text-lg">
              <span>Total</span>
              <span className="font-semibold">1500 MZN</span>
            </div>

            {/* Input de Pagamento */}
            <div className="w-full mb-4">
              <InputPagamento {...propsInputPagamentoMpesa} />
            </div>

            {/* Botão de Pagamento */}
            {loading ? (
              <button className="w-full mt-4 bg-blue-500 p-2 text-white rounded-lg">
                <div className="flex justify-center items-center gap-1">
                  <span>Processando</span>
                  <LoaderCircle
                    strokeWidth={4}
                    size={18}
                    className={loading ? "animate-spin text-white" : ""}
                  />
                </div>
              </button>
            ) : (
              <button
                onClick={() => {
                  recarregarPacote();
                  // Certifique-se de que esta função esteja corretamente definida
                }}
                className="w-full mt-4 bg-blue-500 p-2 text-white rounded-lg hover:bg-blue-400"
              >
                Pagar
              </button>
            )}
            {mensagemInput && (
              <div className="flex items-center text-sm mt-2 p-4 bg-red-500 text-white rounded-lg">
                <OctagonAlert />
                <span>{mensagemInput}</span>
              </div>
            )}

            {/* Aviso sobre termos e condições */}
            <div className="mt-4 text-center text-sm text-gray-400">
              Ao clicar "Pagar", eu confirmo que li e estou de acordo{" "}
              <Link className="text-blue-500 hover:underline" to="/termosdeuso">
                com os termos e condições de uso
              </Link>
            </div>
          </div>
        </div>
      )}
      {/* Footer */}
      <div className="bg-blue-500 text-gray-200 p-2">
        <Footer />
      </div>
    </div>
  );
}
